// LICENSE : MIT
"use strict";

module.exports = {
    "INITIALIZE_NAV": "INITIALIZE_NAV",
    "FOCUS_SITE": "SCROLL_TO_SITE"
};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/page/sites/SiteConst.js
 ** module id = 5
 ** module chunks = 0
 **/